import { Classes, Dialog } from "@blueprintjs/core"
import { LocalLoader } from "modules/common/components/loader/Loader"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import React, { useEffect, useState } from "react"
import { QuestionCardType, QuestionChild } from "../models/card"
import styles from "./MoveChildrenDialog.module.scss"

/**
 * У задания есть подзадания: спрашиваем, забирать ли их на новую доску.
 * Список грузится здесь же — доске он не нужен, пока окно не открыли
 */
export const MoveChildrenDialog: React.FC<MoveChildrenDialogProps> = ({
  card,
  onLoad,
  onConfirm,
  onCancel,
}) => {
  const [children, setChildren] = useState<QuestionChild[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    onLoad(card.id).then((loaded) => {
      if (cancelled) {
        return
      }

      setChildren(loaded)
      setLoading(false)
    })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card.id])

  return (
    <Dialog
      isCloseButtonShown={true}
      isOpen={true}
      onClose={onCancel}
      title="Подзадания"
      backdropClassName="standard"
      className={`figma-dialog ${styles.dialog}`}
    >
      <div className={styles.body}>
        <div className={styles.notice}>
          <GeneralIcon type="general-exclamation" size={16} />
          <span>
            У задания есть подзадания. Перенести их на новую доску вместе с ним? Если нет, они
            останутся на прежней доске и перестанут быть его подзаданиями.
          </span>
        </div>

        {loading ? (
          <div className={styles.loading}>
            <LocalLoader active={true} />
          </div>
        ) : (
          <div className={styles.list}>
            {children.map((child) => (
              <div className={styles.child} key={child.id}>
                <span className={styles.number}>{child.number}</span>
                <span className={styles.title} title={child.title}>
                  {child.title || `Задание ${child.number}`}
                </span>
                {child.stopDay && <span className={styles.date}>{child.stopDay}</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={styles.footer}>
          <PlanrButton type="greenish" onClick={() => onConfirm(true)}>
            Да
          </PlanrButton>
          <PlanrButton type="blueish" onClick={() => onConfirm(false)}>
            Нет
          </PlanrButton>
          <PlanrButton type="graybtn" onClick={onCancel}>
            Отмена
          </PlanrButton>
        </div>
      </div>
    </Dialog>
  )
}

interface MoveChildrenDialogProps {
  card: QuestionCardType
  onLoad: (questionId: string) => Promise<QuestionChild[]>
  /** true — переносим вместе с подзаданиями, false — только само задание */
  onConfirm: (withChildren: boolean) => void
  onCancel: () => void
}
